import _toConsumableArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useRef, useState, useEffect, useMemo } from 'react';
import { useRouter } from 'next/router';
import { Formik } from 'formik';
import useSWR from 'swr';
import { useTranslation } from '@yoweb/next-i18next';
import { Box } from '@yoweb/ui/components/Box';
import { Content as FlyoutContent, FlyoutLayout } from '@poplar/components/Flyout/FlyoutTodo/common';
import { LoadingPage } from '@yoweb/ui/components/LoadingPage';
import { IntakeSummary } from '@poplar/components/Questions/intake-form/IntakeSummary';
import { createTask, updateTask, getQuestionIdentifier } from '@poplar/lib/api/tasks';
import { PAGE_TODO_DETAILS, API_TASKS, PAGE_HOME, API_TASKS_INTERACTION_CONTROLS } from '@poplar/constants/routes';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { getInitialValues, getValidationSchema } from '@poplar/components/Questions/QuestionElements';
import { usePreferredCurrency } from '@poplar/hooks/usePreferredCurrency';
import { trackEvent } from '@yoweb/utils/analytics/mixpanel';
import { answerValuesToQuestion, validateQuestion } from '@poplar/components/Questions/intake-form/utils';
import { QuestionForm } from '@poplar/components/Questions/QuestionForm';
import { TodoEditType } from '@poplar/types/enums';
import { Header } from './Header';
import { TASK_REPEATING_QUESTION_TAG_LABEL } from '@poplar/constants/tasks';
import { Subscribe } from '@poplar/components/tasks/CreateTodoFlyout/TemplatedIntake/Subscribe';
import { fetcher } from '@yoweb/utils/common';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import { useUser } from '@poplar/hooks/useUser';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Wrapper = function Wrapper(props) {
  var initialTask = props.initialTask,
      todoEditType = props.todoEditType,
      title = props.title,
      questionsList = props.questionsList,
      isSubscriptionFlow = props.isSubscriptionFlow;
  var isForRecurringQuestionEdit = todoEditType === TodoEditType.TODO_EDIT_RECURRING_QUESTION;

  var findFirstUnansweredQuestionIndex = function findFirstUnansweredQuestionIndex(questions) {
    return questions.findIndex(function (question) {
      var _question$answerOptio;

      return !((_question$answerOptio = question.answerOptionsList) !== null && _question$answerOptio !== void 0 && _question$answerOptio.some(function (option) {
        var _option$singleChoiceA, _option$textAnswer, _option$dateAnswer, _option$fileAnswer, _option$fileAnswer$an, _option$multipleChoic, _option$multipleChoic2, _option$monthAndDayAn, _option$integerAnswer, _option$doubleAnswer, _option$booleanAnswer, _option$addressAnswer, _option$dateTimeAnswe, _option$idonotknowAns, _option$moneyAnswer;

        return ((_option$singleChoiceA = option.singleChoiceAnswer) === null || _option$singleChoiceA === void 0 ? void 0 : _option$singleChoiceA.answeredValue) || ((_option$textAnswer = option.textAnswer) === null || _option$textAnswer === void 0 ? void 0 : _option$textAnswer.answeredValue) || ((_option$dateAnswer = option.dateAnswer) === null || _option$dateAnswer === void 0 ? void 0 : _option$dateAnswer.answeredDate) || ((_option$fileAnswer = option.fileAnswer) === null || _option$fileAnswer === void 0 ? void 0 : (_option$fileAnswer$an = _option$fileAnswer.answeredValuesList) === null || _option$fileAnswer$an === void 0 ? void 0 : _option$fileAnswer$an.length) || ((_option$multipleChoic = option.multipleChoicesAnswer) === null || _option$multipleChoic === void 0 ? void 0 : (_option$multipleChoic2 = _option$multipleChoic.answeredValuesList) === null || _option$multipleChoic2 === void 0 ? void 0 : _option$multipleChoic2.length) || ((_option$monthAndDayAn = option.monthAndDayAnswer) === null || _option$monthAndDayAn === void 0 ? void 0 : _option$monthAndDayAn.answeredValue) || ((_option$integerAnswer = option.integerAnswer) === null || _option$integerAnswer === void 0 ? void 0 : _option$integerAnswer.answeredValue) || ((_option$doubleAnswer = option.doubleAnswer) === null || _option$doubleAnswer === void 0 ? void 0 : _option$doubleAnswer.answeredValue) || ((_option$booleanAnswer = option.booleanAnswer) === null || _option$booleanAnswer === void 0 ? void 0 : _option$booleanAnswer.answeredValue) || ((_option$addressAnswer = option.addressAnswer) === null || _option$addressAnswer === void 0 ? void 0 : _option$addressAnswer.answeredValue) || ((_option$dateTimeAnswe = option.dateTimeAnswer) === null || _option$dateTimeAnswe === void 0 ? void 0 : _option$dateTimeAnswe.answeredDateTime) || ((_option$idonotknowAns = option.idonotknowAnswer) === null || _option$idonotknowAns === void 0 ? void 0 : _option$idonotknowAns.answeredValue) || ((_option$moneyAnswer = option.moneyAnswer) === null || _option$moneyAnswer === void 0 ? void 0 : _option$moneyAnswer.answeredMoney);
      }));
    });
  };

  var headerElementRef = useRef(null);

  var _useState = useState(function () {
    if (initialTask && isSubscriptionFlow) {
      // When returning to the Subscription Flow after redirect, show the Summary step.
      return initialTask.questionsList.length;
    }

    if (isForRecurringQuestionEdit) {
      var _questionsList$findIn;

      // For recurring edits, show recurring question
      return (_questionsList$findIn = questionsList === null || questionsList === void 0 ? void 0 : questionsList.findIndex(function (question) {
        var _question$tagsList;

        return (_question$tagsList = question.tagsList) === null || _question$tagsList === void 0 ? void 0 : _question$tagsList.some(function (tag) {
          return tag.label === TASK_REPEATING_QUESTION_TAG_LABEL;
        });
      })) !== null && _questionsList$findIn !== void 0 ? _questionsList$findIn : 0;
    } // For normal edits, find first unanswered question


    if (initialTask !== null && initialTask !== void 0 && initialTask.questionsList) {
      var firstUnansweredIndex = findFirstUnansweredQuestionIndex(initialTask.questionsList);

      if (firstUnansweredIndex !== -1) {
        return firstUnansweredIndex;
      }
    }

    return 0;
  }),
      questionIndex = _useState[0],
      setQuestionIndex = _useState[1];

  var _useState2 = useState(function () {
    var _initialTask$pathOfBr;

    if (isForRecurringQuestionEdit && questionsList) {
      // For recurring tasks, make all questions accessible
      return Array.from({
        length: questionsList.length
      }, function (_, i) {
        return i + 1;
      });
    } // For non-recurring tasks, preserve the path for dependent questions


    return (_initialTask$pathOfBr = initialTask === null || initialTask === void 0 ? void 0 : initialTask.pathOfBranchingQuestionsList) !== null && _initialTask$pathOfBr !== void 0 ? _initialTask$pathOfBr : [];
  }),
      pathOfBranchingQuestions = _useState2[0],
      setPathOfBranchingQuestions = _useState2[1];

  useEffect(function () {
    trackEvent({
      todoStepVisit: {
        stepName: questionIndex.toString(),
        title: title !== null && title !== void 0 ? title : '',
        fieldName: ''
      }
    });
  }, [questionIndex, title]);
  var isSubscribeStep = isSubscriptionFlow && !initialTask && questionsList && questionIndex > questionsList.length - 1;
  return /*#__PURE__*/_jsxs(FlyoutLayout, {
    "data-testid": "to-do-intake-layout",
    children: [/*#__PURE__*/_jsx(Header, _objectSpread(_objectSpread({}, props), {}, {
      headerElementRef: headerElementRef,
      questionIndex: questionIndex,
      setQuestionIndex: setQuestionIndex,
      setPathOfBranchingQuestions: setPathOfBranchingQuestions,
      pathOfBranchingQuestions: pathOfBranchingQuestions
    })), /*#__PURE__*/_jsx(Box, {
      position: "relative",
      height: "100%",
      backgroundColor: isSubscribeStep ? 'sandLight' : 'base000',
      children: /*#__PURE__*/_jsx(FlyoutContent, {
        children: /*#__PURE__*/_jsx(Box, {
          justifyContent: "space-between",
          flexDirection: "column",
          height: "100%",
          children: /*#__PURE__*/_jsx(TemplatedInnerWrapper, _objectSpread(_objectSpread({}, props), {}, {
            questionIndex: questionIndex,
            setQuestionIndex: setQuestionIndex,
            pathOfBranchingQuestions: pathOfBranchingQuestions,
            setPathOfBranchingQuestions: setPathOfBranchingQuestions,
            questionsList: questionsList
          }))
        })
      })
    })]
  });
};

var TemplatedInnerWrapper = function TemplatedInnerWrapper(props) {
  var isLoading = props.isLoading,
      questionsList = props.questionsList;

  if (isLoading) {
    return /*#__PURE__*/_jsx(LoadingPage, {});
  }

  if (!questionsList) {
    // TODO: need a state for misconfigured todos OR filter them out?
    return null;
  }

  return /*#__PURE__*/_jsx(TemplatedInner, _objectSpread(_objectSpread({}, props), {}, {
    questionsList: questionsList
  }));
};

var TemplatedInner = function TemplatedInner(_ref) {
  var _questionsList$map$re;

  var title = _ref.title,
      description = _ref.description,
      initialQuestionsList = _ref.questionsList,
      initialTask = _ref.initialTask,
      initialError = _ref.error,
      questionIndex = _ref.questionIndex,
      setQuestionIndex = _ref.setQuestionIndex,
      _onSaveDraft = _ref.onSaveDraft,
      onHandOff = _ref.onHandOff,
      onDirtyChange = _ref.onDirtyChange,
      taskTemplateId = _ref.taskTemplateId,
      pathOfBranchingQuestions = _ref.pathOfBranchingQuestions,
      setPathOfBranchingQuestions = _ref.setPathOfBranchingQuestions,
      todoEditType = _ref.todoEditType,
      onSlideClose = _ref.onSlideClose,
      isSubscriptionFlow = _ref.isSubscriptionFlow,
      hasActiveSubscription = _ref.hasActiveSubscription;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var _useState3 = useState(initialError),
      error = _useState3[0],
      setError = _useState3[1];

  var router = useRouter();

  var _useIntlMeta = useIntlMeta(),
      country = _useIntlMeta.country,
      locale = _useIntlMeta.locale;

  var currency = usePreferredCurrency();

  var _useState4 = useState(initialQuestionsList),
      questionsList = _useState4[0],
      setQuestionsList = _useState4[1];

  var _useState5 = useState(true),
      isFirstFetchOfQuestionList = _useState5[0],
      setIsFirstFetchOfQuestionList = _useState5[1];

  var _useState6 = useState(false),
      loadingDependentQuestion = _useState6[0],
      setLoadingDependentQuestion = _useState6[1];

  var _useState7 = useState([]),
      selectedAnswerOptionDependencies = _useState7[0],
      setSelectedAnswerOptionDependencies = _useState7[1];

  var question = questionsList[questionIndex];
  var validationSchema = useMemo(function () {
    return getValidationSchema(question, selectedAnswerOptionDependencies, t, country);
  }, [country, question, selectedAnswerOptionDependencies, t]);

  var _useSWR = useSWR(!initialTask ? null : "".concat(API_TASKS, "/").concat(initialTask.taskId), fetcher),
      mutateTask = _useSWR.mutate;

  var _useExternalConfig = useExternalConfig(),
      _useExternalConfig$gl = _useExternalConfig.globalFeatures,
      enablePrimeProPreview = _useExternalConfig$gl.enablePrimeProPreview,
      enableOnboarding2_2 = _useExternalConfig$gl.enableOnboarding2_2;

  var user = useUser();

  var _useSWR2 = useSWR(user.isAuthenticated && taskTemplateId ? API_TASKS_INTERACTION_CONTROLS(initialTask === null || initialTask === void 0 ? void 0 : initialTask.taskId, taskTemplateId) : undefined, fetcher, {
    shouldRetryOnError: false
  }),
      taskInteractionControls = _useSWR2.data;

  var allowPreviewHandoff = enablePrimeProPreview && (taskInteractionControls === null || taskInteractionControls === void 0 ? void 0 : taskInteractionControls.allowHandoff); // Since we fill `question.id` with a uuid, any SWR revalidation will cause de-referrencing errors because the id will change.
  // Shawdowing the initialQuestionsList with a local state to avoid this issue.

  useEffect(function () {
    if (isFirstFetchOfQuestionList && initialQuestionsList !== null && initialQuestionsList !== void 0 && initialQuestionsList.length) {
      setQuestionsList(initialQuestionsList);
      setIsFirstFetchOfQuestionList(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [initialQuestionsList]);

  var onSubmitSuccess = function onSubmitSuccess() {
    if (enableOnboarding2_2 && hasActiveSubscription && isSubscriptionFlow) {
      void router.push(PAGE_HOME);
      return;
    } // automatically refresh the task details page if the user is currently viewing it


    if (router.pathname === PAGE_TODO_DETAILS('[taskId]')) {
      void router.replace({
        pathname: router.pathname,
        query: _objectSpread({}, router.query)
      });
      void mutateTask();
    }
  };

  var saveTask = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(props) {
      var _props$questionsList$, _props$questionsList$2, _props$questionsList$3, _props$questionsList$4, _props$questionsList$5, _ref3;

      var saveCurrentQuestionBranchPath,
          newPathOfBranchingQuestions,
          todoTitle,
          payload,
          mutatedTask,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              saveCurrentQuestionBranchPath = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
              newPathOfBranchingQuestions = pathOfBranchingQuestions;

              if (saveCurrentQuestionBranchPath && !pathOfBranchingQuestions.includes(questionIndex + 1)) {
                newPathOfBranchingQuestions = [].concat(_toConsumableArray(pathOfBranchingQuestions), [questionIndex + 1]);
              } // Extract title from the display_name question


              todoTitle = (_props$questionsList$ = props.questionsList.find(function (q) {
                var _q$answerOptionsList;

                return (_q$answerOptionsList = q.answerOptionsList) === null || _q$answerOptionsList === void 0 ? void 0 : _q$answerOptionsList.some(function (a) {
                  var _a$tag;

                  return ((_a$tag = a.tag) === null || _a$tag === void 0 ? void 0 : _a$tag.label) === 'display_name';
                });
              })) === null || _props$questionsList$ === void 0 ? void 0 : (_props$questionsList$2 = _props$questionsList$.answerOptionsList) === null || _props$questionsList$2 === void 0 ? void 0 : (_props$questionsList$3 = _props$questionsList$2.find(function (a) {
                var _a$tag2;

                return ((_a$tag2 = a.tag) === null || _a$tag2 === void 0 ? void 0 : _a$tag2.label) === 'display_name';
              })) === null || _props$questionsList$3 === void 0 ? void 0 : (_props$questionsList$4 = _props$questionsList$3.textAnswer) === null || _props$questionsList$4 === void 0 ? void 0 : (_props$questionsList$5 = _props$questionsList$4.answeredValue) === null || _props$questionsList$5 === void 0 ? void 0 : _props$questionsList$5.value;
              payload = {
                title: (_ref3 = todoTitle !== null && todoTitle !== void 0 ? todoTitle : title) !== null && _ref3 !== void 0 ? _ref3 : '',
                description: description,
                taskTemplateId: props.taskTemplateId,
                questionsList: props.questionsList,
                pathOfBranchingQuestions: newPathOfBranchingQuestions
              };

              if (!(props !== null && props !== void 0 && props.taskId)) {
                _context.next = 11;
                break;
              }

              _context.next = 8;
              return updateTask(props.taskId, payload);

            case 8:
              mutatedTask = _context.sent.data;
              _context.next = 14;
              break;

            case 11:
              _context.next = 13;
              return createTask(payload);

            case 13:
              mutatedTask = _context.sent.data;

            case 14:
              if (!mutatedTask) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return", mutatedTask);

            case 16:
              throw new Error('Save task failed in an unexpected way.');

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function saveTask(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onNext = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(answeredQuestionsList, dontIncrementIndex) {
      var _answeredQuestion$ans, _answeredQuestion$ans2, _answeredQuestion$ans3;

      var answeredQuestion, jumpQuestionIndex, nextQuestionIndex, _questionIdentifierRe, _questionIdentifierRe2, questionIdentifierResponse;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              answeredQuestion = answeredQuestionsList[questionIndex];
              setError(undefined);

              if (!pathOfBranchingQuestions.includes(questionIndex + 1)) {
                setPathOfBranchingQuestions([].concat(_toConsumableArray(pathOfBranchingQuestions), [questionIndex + 1]));
              } // Single choice questions with jumpToQuestionWithOrder should jump to that question


              jumpQuestionIndex = answeredQuestion === null || answeredQuestion === void 0 ? void 0 : (_answeredQuestion$ans = answeredQuestion.answerOptionsList.find(function (option) {
                var _option$singleChoiceA2, _option$singleChoiceA3;

                return (_option$singleChoiceA2 = option.singleChoiceAnswer) === null || _option$singleChoiceA2 === void 0 ? void 0 : (_option$singleChoiceA3 = _option$singleChoiceA2.answeredValue) === null || _option$singleChoiceA3 === void 0 ? void 0 : _option$singleChoiceA3.jumpToQuestionWithOrder;
              })) === null || _answeredQuestion$ans === void 0 ? void 0 : (_answeredQuestion$ans2 = _answeredQuestion$ans.singleChoiceAnswer) === null || _answeredQuestion$ans2 === void 0 ? void 0 : (_answeredQuestion$ans3 = _answeredQuestion$ans2.answeredValue) === null || _answeredQuestion$ans3 === void 0 ? void 0 : _answeredQuestion$ans3.jumpToQuestionWithOrder;

              if (!jumpQuestionIndex) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt("return", setQuestionIndex(jumpQuestionIndex - 1));

            case 6:
              nextQuestionIndex = questionIndex + 1;

              if (!(answeredQuestion.dependentQuestionAnswerOptionIdentifiers && answeredQuestion.dependentQuestionAnswerOptionIdentifiers.dependentQuestionAnswerOptionIdentifiersList.length > 0 && taskTemplateId)) {
                _context2.next = 19;
                break;
              }

              setLoadingDependentQuestion(true);
              _context2.prev = 9;
              _context2.next = 12;
              return getQuestionIdentifier({
                templateId: taskTemplateId,
                currentQuestionIdentifier: questionIndex + 1,
                // questions are not 0 indexed
                questions: answeredQuestionsList
              });

            case 12:
              questionIdentifierResponse = _context2.sent;

              if ((_questionIdentifierRe = questionIdentifierResponse.data) !== null && _questionIdentifierRe !== void 0 && _questionIdentifierRe.destinationQuestionIdentifier) {
                nextQuestionIndex = questionIdentifierResponse.data.destinationQuestionIdentifier - 1; // adjusting for 0 indexed array
              } else if ((_questionIdentifierRe2 = questionIdentifierResponse.data) !== null && _questionIdentifierRe2 !== void 0 && _questionIdentifierRe2.endOfQuestions) {
                nextQuestionIndex = answeredQuestionsList.length;
              }

            case 14:
              _context2.prev = 14;
              setLoadingDependentQuestion(false);
              return _context2.finish(14);

            case 17:
              _context2.next = 20;
              break;

            case 19:
              if (answeredQuestion.defaultDestinationQuestionIdentifier > 0) {
                nextQuestionIndex = answeredQuestion.defaultDestinationQuestionIdentifier - 1;
              }

            case 20:
              if (!dontIncrementIndex) {
                setQuestionIndex(nextQuestionIndex);
              }

              return _context2.abrupt("return", answeredQuestionsList);

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[9,, 14, 17]]);
    }));

    return function onNext(_x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  var initialValues = (_questionsList$map$re = questionsList.map(function (q) {
    return getInitialValues(q, {
      locale: locale,
      currency: currency,
      country: country
    });
  }).reduce(function (result, current) {
    return _objectSpread(_objectSpread({}, result), current);
  }, {})) !== null && _questionsList$map$re !== void 0 ? _questionsList$map$re : {};
  return /*#__PURE__*/_jsx(Formik, {
    onSubmit: function onSubmit() {},
    initialValues: initialValues,
    validationSchema: validationSchema,
    enableReinitialize: true,
    validateOnMount: true,
    children: function children(formikProps) {
      if (questionIndex > questionsList.length - 1) {
        var answeredIntakeQuestions = questionsList.map(function (q) {
          return answerValuesToQuestion(q, formikProps.values, country);
        });

        if (isSubscriptionFlow && !initialTask && !hasActiveSubscription) {
          return /*#__PURE__*/_jsx(Subscribe, {
            saveTask: function (_saveTask) {
              function saveTask() {
                return _saveTask.apply(this, arguments);
              }

              saveTask.toString = function () {
                return _saveTask.toString();
              };

              return saveTask;
            }(function () {
              return saveTask({
                questionsList: answeredIntakeQuestions
              }).then(function (savedTask) {
                return savedTask.taskId;
              });
            }),
            handleSaveDraft: function handleSaveDraft() {
              return _onSaveDraft(answeredIntakeQuestions, saveTask, onSubmitSuccess);
            }
          });
        }

        return /*#__PURE__*/_jsx(IntakeSummary, {
          questionsList: answeredIntakeQuestions,
          onHandoff: function onHandoff() {
            return onHandOff(answeredIntakeQuestions, saveTask, onSubmitSuccess);
          },
          onSaveDraft: function onSaveDraft() {
            return _onSaveDraft(answeredIntakeQuestions, saveTask, onSubmitSuccess);
          },
          initialTask: initialTask,
          pathOfBranchingQuestions: pathOfBranchingQuestions !== null && pathOfBranchingQuestions !== void 0 ? pathOfBranchingQuestions : [],
          isSubscriptionFlow: isSubscriptionFlow,
          taskTemplateId: taskTemplateId
        });
      }

      return /*#__PURE__*/_jsx(QuestionForm, {
        question: question,
        error: error,
        initialTask: initialTask,
        loadingDependentQuestion: loadingDependentQuestion,
        formikProps: formikProps,
        selectedAnswerOptionDependencies: selectedAnswerOptionDependencies,
        setSelectedAnswerOptionDependencies: setSelectedAnswerOptionDependencies,
        onDirtyChange: onDirtyChange,
        onSave: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var questionsWithAnswers, saveCurrentQuestionBranchPath;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  //Convert formik values to question values
                  questionsWithAnswers = questionsList.map(function (q) {
                    return answerValuesToQuestion(q, formikProps.values, country);
                  });
                  saveCurrentQuestionBranchPath = validateQuestion(questionsWithAnswers[questionIndex]);
                  _context3.next = 4;
                  return _onSaveDraft(questionsWithAnswers, function (props) {
                    return saveTask(props, saveCurrentQuestionBranchPath);
                  }, onSubmitSuccess);

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        })),
        onNext: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var questionsWithAnswers;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  // Convert formik values to question values
                  questionsWithAnswers = questionsList.map(function (q) {
                    return answerValuesToQuestion(q, formikProps.values, country);
                  });
                  _context4.next = 3;
                  return onNext(questionsWithAnswers);

                case 3:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        })),
        onClose: onSlideClose,
        todoEditType: todoEditType,
        hideDraftBtn: isSubscriptionFlow,
        submitBtnLabel: isSubscriptionFlow ? 'actions.continue' : undefined,
        disableUpsellBanner: allowPreviewHandoff || isSubscriptionFlow,
        allowPreviewHandoff: allowPreviewHandoff,
        taskTemplateId: taskTemplateId
      });
    }
  });
};